export default function ProblemSection() {
  const cycleSteps = [
    {
      icon: "ri-moon-fill",
      label: "夜になる",
      sub: "帰宅後・就寝前の時間帯",
      color: "#6B5CE7",
    },
    {
      icon: "ri-store-2-fill",
      label: "コンビニ・デリバリーへ",
      sub: "気づけば向かっている",
      color: "#E05040",
    },
    {
      icon: "ri-emotion-fill",
      label: "「今日だけならいいか」",
      sub: "その場の気持ちに負ける",
      color: "#E07040",
    },
    {
      icon: "ri-repeat-2-fill",
      label: "また買って食べてしまう",
      sub: "そして後悔のループへ",
      color: "#B04040",
    },
  ];

  return (
    <section className="bg-[#FAF7F4] py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-sm text-[#B07040] font-bold tracking-widest uppercase mb-3">ROOT CAUSE</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            甘いものやジャンクフードが続いてしまう本当の理由は、<br className="hidden md:block" />
            意志ではなく<span className="text-[#E05040]">「買えてしまうこと」</span>です
          </h2>
          <p className="text-[#666] text-base mt-5 max-w-xl mx-auto leading-relaxed">
            多くの人は「意志が弱いから」と思いますが、実際は<br className="hidden md:block" />
            <strong className="text-[#1a1a1a]">この流れが残っている限り</strong>、我慢だけで続けるのは困難です。
          </p>
        </div>

        {/* ループカード */}
        <div className="relative">
          {/* 背景の「負のループ」ラベル */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full border-4 border-dashed border-[#E05040]/20 flex items-center justify-center">
              <div className="text-center">
                <p className="text-[#E05040]/40 text-xs font-bold tracking-widest">負のループ</p>
                <i className="ri-refresh-fill text-4xl md:text-5xl text-[#E05040]/20"></i>
              </div>
            </div>
          </div>

          {/* 4ステップカード */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10">
            {cycleSteps.map((step, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-5 flex items-center gap-4 border border-[#EEE]"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: step.color + "18" }}
                >
                  <i
                    className={`${step.icon} text-2xl`}
                    style={{ color: step.color }}
                  ></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span
                      className="text-xs font-black rounded-full px-2 py-0.5 text-white"
                      style={{ backgroundColor: step.color }}
                    >
                      0{i + 1}
                    </span>
                  </div>
                  <p className="text-[#1a1a1a] text-sm font-black">{step.label}</p>
                  <p className="text-[#999] text-xs mt-0.5">{step.sub}</p>
                </div>
                {i < cycleSteps.length - 1 && (
                  <div className="hidden md:block absolute" />
                )}
              </div>
            ))}
          </div>

          {/* 矢印（PC: カード間）*/}
          <div className="hidden md:flex justify-center items-center gap-4 mt-4 mb-2">
            <div className="flex-1 h-px bg-[#E05040]/20"></div>
            <div className="flex items-center gap-2 text-[#E05040]/60 text-xs font-bold">
              <i className="ri-refresh-fill text-lg"></i>
              <span>このループが繰り返される</span>
            </div>
            <div className="flex-1 h-px bg-[#E05040]/20"></div>
          </div>

          {/* モバイル用のループ説明 */}
          <div className="flex md:hidden justify-center mt-4">
            <div className="flex items-center gap-2 text-[#E05040]/70 text-xs font-bold">
              <i className="ri-refresh-fill text-base"></i>
              <span>このループが繰り返される</span>
            </div>
          </div>
        </div>

        {/* 結論ボックス */}
        <div className="mt-8 bg-[#FFF4F2] border-l-4 border-[#E05040] rounded-r-2xl p-6">
          <p className="text-[#1a1a1a] text-base leading-relaxed">
            <strong className="text-[#E05040]">「買えてしまう環境」</strong>が残っている限り、どれだけ決意しても続けるのは難しい。<br className="hidden md:block" />
            YAMEBIは、この流れの入口にある<strong className="text-[#E05040]">「買えてしまう」</strong>を変えるサービスです。
          </p>
        </div>
      </div>
    </section>
  );
}
